import { useState, useEffect } from 'react'

import "./AvailableCard.css";

import { useDrag } from 'react-dnd'

export default function AvailableCard({ cardName, houseCard, numberOwned, isDropped, handleCardSelect, cardCollection, setDropIndicator, draggable }) {
    const [stroke, setStroke] = useState(false);
    const [count, setCount] = useState();
    const handleMouseOver = () => {
        setStroke(true);
    }
    const handleMouseLeave = () => {
        setStroke(false);
    }
    const [{ dropIndicator }, drag] = useDrag(() => ({
        // "type" is required. It is used by the "accept" specification of drop targets.
        type: 'BOX',
        // The collect function utilizes a "monitor" instance (see the Overview for what this is)
        // to pull important pieces of state from the DnD system.
        item: { cardName, houseCard },
        collect: (monitor) => ({
            dropIndicator: monitor.isDragging() ? true : false
        })
    }))
    useEffect(() => {
        setDropIndicator(dropIndicator);
    }, [dropIndicator])

    useEffect(() => {
        if (cardCollection.housePowerCards.has(cardName)) {
            setCount(cardCollection.housePowerCards.get(cardName));
        } else if (cardCollection.nftPowerCards.has(cardName)) {
            setCount(cardCollection.nftPowerCards.get(cardName));
        }
    }, [cardCollection])
    // useEffect(() => {
    //     // console.log("cardSlotsRef log in availablecard", cardSlotsRef);
    //     // console.log("useEfect call in available card")
    //     for (var card in cardSlotsRef.current) {
    //         // console.log("available card log", cardSlotsRef.current[card]);
    //         if (cardSlotsRef.current[card].image === cardName) {
    //             // console.log(numberOwned - cardSlotsRef.current[card].count)
    //             var n = numberOwned - cardSlotsRef.current[card].count
    //             if (n < 0) {
    //                 setCount(0);
    //             } else {
    //                 setCount(numberOwned - cardSlotsRef.current[card].count);
    //             }
    //         }
    //     }
    // }, [cardSlotsRef, cardSlots])
    return (
        <div onClick={() => { handleCardSelect(cardName, houseCard) }} onMouseOver={() => { handleMouseOver() }} onMouseLeave={() => { handleMouseLeave() }} className="available-card-container">
            <div ref={(draggable && count > 0) ? drag : null}>
                {houseCard ?
                    <img
                        src={`/bonez/images/cards/power-cards/${cardName.toString()}.svg`}
                        alt=""
                        className="available-card"
                        style={{
                            opacity: count <= 0 ? "0.3" : "1",
                            cursor: isDropped ? "" : "pointer",
                            border: stroke && count !== 0 ? "2px solid #BD00FF" : "2px solid #161B2F"
                        }}
                        draggable={count > 0 && draggable}
                    />

                    :

                    <img
                        src={`/bonez/images/cards/power-cards/${cardName.toString()}.svg`}
                        alt=""
                        className="available-card"
                        style={{
                            opacity: count <= 0 ? "0.3" : "1",
                            cursor: isDropped ? "" : "pointer",
                            border: stroke && count !== 0 ? "2px solid #BD00FF" : "2px solid #161B2F"
                        }}
                        draggable={count > 0 && draggable}
                    />
                }
            </div>
            <div className="available-card-text-container">
                <span className="available-card-text">
                    {"x" + count}
                </span>
            </div>
        </div>
    )
}